import React from "react";

export function translate(key, nullOnFailure = false, params = {}) {
    return Core.loca.get(key, nullOnFailure)?.replace(/\[([a-zA-Z0-9_\-.]+)\]/g, (full, match) => params[match] !== undefined ? params[match] : full);
}

export function getTranslator(prefix) {
    return (key, params) => translate(composeTranslationKey(prefix, key), false, params);
}

export const composeTranslationKey = (keyPath, key) => keyPath + (keyPath ? '/' : '') + key;

/**
 * Returns the first key, that has a translation in a translation path.
 */
export const translateTryKeys = (keyPath, ...keys) => {
    return keys.reduce((nullOrValue, currentKey) => {
        if(nullOrValue !== null) {
            return nullOrValue;
        }
        return translate(composeTranslationKey(keyPath, currentKey), true);
    }, null);
}

export function TranslationNode({ translate, tKey, params }) {
    return <span dangerouslySetInnerHTML={{ __html: translate(tKey, params) }}></span>
}

export default translate;